import { GlobalContext } from 'context/GlobalProvider';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useReloadRedirect() {
    const {
        state: { accountNbr },
        actions: { resetState }
    } = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (accountNbr === '') {
            resetState();
            navigate('/');
        }
    }, [accountNbr, navigate, resetState]);
}
